import { render, staticRenderFns } from "./PwaPromptIos.vue?vue&type=template&id=45d12a39&scoped=true&"
import script from "./PwaPromptIos.vue?vue&type=script&lang=js&"
export * from "./PwaPromptIos.vue?vue&type=script&lang=js&"
import style0 from "./PwaPromptIos.vue?vue&type=style&index=0&id=45d12a39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d12a39",
  null
  
)

export default component.exports